export const strings = {
  NAME: "Text",
  DESCRIPTION: "Add context and link to useful resources.",
  KEYWORDS: "markdown rich text",
} as const;
